// removed by extract-text-webpack-plugin
module.exports = {"workerTab":"_1N7ipvXqugbMP4zzUxkXl5"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/worker/workerTab/workerTab.scss
// module id = 13553
// module chunks = 0